import { Button, EditIcon, PlusIcon, SelectBox, Text } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import type { AddressListProps } from './address-list.type'

import styles from './address-list.module.css'

export const AddressList = ({
  onClickNewAddress,
  addresses,
  onChangeAddressSelected,
  addressSelected,
  onEditAddress,
}: AddressListProps) => {
  const { t } = useTranslation('componentsAddressList')

  return (
    <div className={styles.core}>
      <div>
        <Text variant="text-large-bold">{t('addressListTitle')}</Text>
        <Text>{t('addressListDescription')}</Text>
      </div>

      {addresses?.map((address) => (
        <SelectBox
          title={`${t('addressListDeliveryAt')} ${address?.city || address?.postalCode}`}
          onChange={() => onChangeAddressSelected(address)}
          value={addressSelected?.uuid === address.uuid}
          key={address.uuid}
        >
          <div className={styles['address-content']}>
            <div>
              {`
            ${address.country ? `${address.country}` : ''} 
            ${address.state ? `, ${address.state}` : ''}
            ${address.city ? `, ${address.city}` : ''}
            ${address.neighborhood ? `, ${address.neighborhood}` : ''}
            ${address.street ? `, ${address.street}` : ''}
            ${address.number && address.number !== 0 ? `, ${address.number}` : ''}
            ${address.postalCode ? `, ${address.postalCode}` : ''}
            ${address.reference ? ` (${address.reference})` : ''}
          `}
            </div>
            {onEditAddress && (
              <div className={styles['button-box']}>
                <Button
                  variant="secondary"
                  model="square"
                  onClick={() => onEditAddress(address)}
                >
                  <EditIcon />
                </Button>
              </div>
            )}
          </div>
        </SelectBox>
      ))}

      <Button onClick={onClickNewAddress} variant="light">
        <PlusIcon />
        {t('addressListButton')}
      </Button>
    </div>
  )
}
